export const postingSelector: (state: RootState) => Posting[]|undefined
    = (state: RootState) => state.posting.initialized ? state.posting.postings : undefined;
